export default "__VITE_ASSET__dD5xyYJYTjiy6ZDbzgg4Uw__"